module.exports = __webpack_public_path__ + "media/images/default/pages/about/doctor-3-23bfdf186fb9a7a871c3ca8471045c46.jpg";